import React, {useEffect, useState} from "react";
import {api} from "../utils/gashtaltAPI";
import Loader from "../components/Loader";
import ErrorPage from "../components/ErrorPage";
import Navbar from "../components/Navbar";
import {useNavigate, useParams} from "react-router-dom";
import {toPersianNumber} from "../utils/numberConversion";
import DownloadHandler from "../utils/downloadHandler";

function Result() {
    const {examId} = useParams();
    const [report, setReport] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await api.get('/api/exam/result/' + examId);
                setReport(response.data.data);

            } catch (error) {
                setError(error)
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, []);
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await api.get('/api/exam/answers/' + examId);
                setAnswers(response.data.data);
            } catch (error) {
                setError(error)
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, []);

    if (loading) return <Loader/>;
    if (error) return <ErrorPage error={error}/>;

    return (
        <div className="d-flex flex-column h-100">
            <Navbar/>
            <div className="result-container flex-fill d-flex flex-column justify-content-between">
                <div className="result">
                    <h2 className={'text-center'}>{report?.exam_name}</h2>
                    <div className={'d-flex flex-row justify-content-around result-detail'}>
                        <p>
                            تعداد کل سوالات :
                            {toPersianNumber(report?.total_question_count)}
                        </p>
                        <p className="correct-answer">
                            پاسخ های صحیح :
                            {toPersianNumber(report?.correct_answers)}
                        </p>
                        <p className="wrong-answer">
                            پاسخ های غلط :
                            {toPersianNumber(report?.wrong_answers)}
                        </p>
                    </div>
                    <div className={'d-flex flex-row justify-content-around result-detail'}>
                        <p className={report?.score > 0 ? 'correct-answer' : 'wrong-answer'}> 
                            درصد پاسخگویی :
                            <span className="mx-1">{toPersianNumber(report?.score)}</span>
                            <span className="mx-1">درصد</span>
                        </p>
                        <p>
                            تعداد کل شرکت کنندگان :
                            {toPersianNumber(report?.participants)}
                        </p>
                        <p>
                            رتبه شما   :
                            {toPersianNumber(report?.rank)}
                        </p>
                    </div>
                    <ul className="modal-options">
                        {answers.map((question, index) => question !== null ? (
                            <li key={index} className="d-flex flex-row justify-content-center align-items-center">
                                <h4>سوال {toPersianNumber(index + 1)} : </h4>
                                {question.optionCount.map((id, i) => (
                                    <span key={id}
                                          className={
                                              `option counter ${id === question.correct && id === question.userSelected ? 'selected' : ''}
                                         ${id !== question.correct && id === question.userSelected ? 'wrong-answer' : ''}
                                         ${id === question.correct && id !== question.userSelected ? 'correct-answer' : ''}
                                         `}>
                                        <div>{toPersianNumber(i + 1)}</div>
                                    </span>
                                ))}
                            </li>
                        ) : null)}
                    </ul>
                    <div className={"row gap-3 justify-content-center"}>
                    {/*<div className={"row gap-3 justify-content-center"}>
                        <button className="btn btn-outline-green col-3" onClick={() => {
                            navigate(`/videos/${examId}`)
                        }}>تحلیل ویدیویی
                        </button>
                        </div>*/}
                        {report?.questions_file && (
                            <button className="btn btn-outline-blue col-3" onClick={() => {
                                DownloadHandler(report.questions_file)
                            }}>سوالات
                            </button>
                        )}
                        {report?.answers_file && (
                            <button className="btn btn-outline-green col-3" onClick={() => {
                                DownloadHandler(report.answers_file)
                            }}>پاسخنامه
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Result;